import { PayloadAction } from "@reduxjs/toolkit";
import { notificationsActions } from "modules/notifications/slices";
import { NOTIFICATION_TYPES } from "modules/notifications/types";
import { SagaIterator } from "redux-saga";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { getAxiosErrorMessage } from "utils/getAxiosErrorMessage";
import { axiosInstance } from "../../axios";
import { supportActions } from "./slices";
import { SubmitTicketParams } from "./types";

const serviceApiPath = `gotham-asylum/method`;

export function* submitTicketSaga(
  action: PayloadAction<SubmitTicketParams>
): SagaIterator<void> {
  try {
    const { subject, description, priority, customer_id, mobile } =
      action.payload;
    yield call(axiosInstance.post, `${serviceApiPath}/sn/create-ticket`, {
      subject,
      description,
      priority,
      customer_id,
      mobile
    });

    yield put(supportActions.submitTicketSuccess());
    yield put(
      notificationsActions.showNotification({
        title: "Ticket has been successfully created.",
        type: NOTIFICATION_TYPES.SUCCESS
      })
    );
  } catch (e) {
    yield put(
      supportActions.submitTicketFailure({
        params: action.payload,
        error: getAxiosErrorMessage(e)
      })
    );
    yield put(
      notificationsActions.showNotification({
        title: "Failed to create ticket.",
        text: getAxiosErrorMessage(e),
        type: NOTIFICATION_TYPES.ERROR
      })
    );
  }
}

export function* watcherSaga(): SagaIterator<void> {
  yield all([takeEvery(supportActions.submitTicketRequest, submitTicketSaga)]);
}
